import { apiV2 } from '../lib/baseAxios';
import { IVFSResponse } from './fileSystemService';

export interface InitGoogleCalendarIntegrationData {
  oauthUrl: string;
}

export const initGoogleCalendarIntegration = async (): Promise<InitGoogleCalendarIntegrationData> => {
  const response = await apiV2.get<
    IVFSResponse<InitGoogleCalendarIntegrationData>
  >(`/integrate/google/calendar/init`);
  return response.data.data;
};

export const disconnectGoogleCalendarIntegration = async (): Promise<
  string | undefined
> => {
  const response = await apiV2.post<IVFSResponse<unknown>>(
    `/integrate/google/calendar/disconnect`
  );
  return response.data.message;
};

export const disconnectZoomIntegration = async (): Promise<
  string | undefined
> => {
  const response = await apiV2.post<IVFSResponse<unknown>>(
    `/integrate/zoom/disconnect`
  );
  return response.data.message;
};

export const connectZoomIntegration = async (): Promise<{
  oauthUrl?: string;
}> => {
  const response = await apiV2.get<IVFSResponse<{ oauthUrl?: string }>>(
    `/integrations/zoom/connect`
  );
  return response?.data?.data ?? {};
};

export const addUserWebhookUrl = async ({
  name,
  url,
  templateId,
}: {
  name: string;
  url: string;
  templateId: string;
}) => {
  return apiV2.post(`/integrations/webhook`, { name, url, templateId });
};

export const removeUserWebhookUrl = async ({ url }: { url: string }) => {
  return apiV2.delete(`/integrations/webhook`, { params: { url } });
};

/**
 * Initialize Microsoft Teams Calendar integration
 */
export async function initMicrosoftTeamsCalendar(): Promise<{
  oauthUrl: string;
}> {
  const response = await apiV2.get<IVFSResponse<{ oauthUrl: string }>>(
    '/integrate/microsoft/calendar/init'
  );
  return response.data.data;
}

/**
 * Disconnect Microsoft Teams Calendar integration
 */
export async function disconnectMicrosoftTeamsCalendar(): Promise<
  string | undefined
> {
  const response = await apiV2.post<IVFSResponse<unknown>>(
    '/integrate/microsoft/calendar/disconnect'
  );
  return response.data.message;
}

/**
 * Initialize Zoom Meetings integration
 */
export async function initZoomMeetings(): Promise<{
  oauthUrl: string;
}> {
  const response = await apiV2.get<IVFSResponse<{ oauthUrl: string }>>(
    '/integrate/zoom/meetings/init'
  );
  return response.data.data;
}
